<template>
  <div>

    <div class="form-row">
      <div class="col-12 d-flex align-items-center flex-wrap mb-3 flex-column flex-sm-row text-center">
        <h5 class="text-blue-ml">* Experiências Profissionais</h5>

        <button type="button" class="btn btn-outline-blue-ml ml-0 ml-sm-auto" @click="edit(null)">
            Adicionar Exp. Profissional
        </button>
      </div>

      <div class="col-12 mb-4" v-for="(experience, index) in experiences" :key="index">
        <div class="d-flex align-items-center justify-content-between justify-content-md-start">
          <div class="mr-3">
            <h5 class="mb-0">{{ experience.role }}</h5>
            <p class="mb-0">{{ experience.company }}</p>
          </div>

          <div class="btn-group" role="group">
            <button type="button" class="btn btn-light" @click="edit(experience)"> <pencil-icon class="align-text-bottom text-blue-ml" /> </button>
            <button type="button" class="btn btn-light" @click="remove(experience.id)"> <delete-icon class="align-text-bottom text-blue-ml" /> </button>
          </div>
        </div>

        <p class="text-muted">
          {{ $moment(experience.startYear).format('YYYY') }}
          <span v-if="experience.endYear">
            - {{ $moment(experience.endYear).format('YYYY') }}
            <small class="mx-1">●</small>
            {{ dateRange(experience.startYear, experience.endYear) }}
          </span>
          <span v-else>
            - Atualmente
            <small class="mx-1">●</small>
            {{ dateRange(experience.startYear, new Date()) }}
          </span>
        </p>

        <div v-if="experience.responsabilities">
          <h6>Responsabilidades</h6>
          <p v-if="experience.responsabilities.length > 120">{{ experience.responsabilities.substring(0, 120) }}...</p>
          <p v-else>{{ experience.responsabilities }}</p>
        </div>
      </div>
    </div>

    <div class="custom-control custom-checkbox pb-3 pl-0 w-100" v-if="experiences.length == 0">
      <div class="d-flex pb-4">
        <input type="checkbox" class="custom-control-input" style="position: relative; width: 1.7rem;" :id="'no-professional-exp' + format" v-model="no_experiences" value="true">
        <label class="custom-control-label" :for="'no-professional-exp' + format">Não possuo experiência profissional</label>
      </div>
    </div>

    <b-modal ref="modal-professional-exp" size="lg" centered :hide-header="true" :hide-footer="true" no-close-on-backdrop lazy>
      <div class="py-4 px-2 px-lg-4">
        <h4 class="text-blue-ml mb-4">EXPERIÊNCIA PROFISSIONAL</h4>

        <button type="button" class="ml-auto close" @click="$refs['modal-professional-exp'].hide()">
          <close-icon class="h4 my-0 ml-auto" />
        </button>

        <FormProfessionalExp @closeModal="$refs['modal-professional-exp'].hide()" hasButtons />
      </div>
    </b-modal>

    <div v-if="format == 'inline-form' && experiences.length == 0 && $route.name == 'deixe-seu-perfil'" v-show="no_experiences == false">
      <div class="form-area mt-4 mb-5" :class="{ 'has-multiple': formsIds.length > 1 }" v-for="(item, index) in formsIds" :key="index">
        <FormProfessionalExp storeByEventBus />
        <div class="d-flex" v-if="formsIds.length > 1">
          <button class="btn btn-link btn-lg p-0 ml-auto" @click="removeForm(item)"> <u>Remover Exp. Profissional</u> </button>
        </div>
      </div>

      <div class="d-flex mt-5">
        <button class="btn btn-outline-blue-ml btn-lg mx-auto" @click="addForm()">Adicionar Exp. Profissional</button>
      </div>
    </div>

  </div>
</template>

<script>
import CloseIcon from 'vue-material-design-icons/Close.vue';
import PencilIcon from 'vue-material-design-icons/Pencil.vue';
import DeleteIcon from 'vue-material-design-icons/Delete.vue';
import FormProfessionalExp from './FormProfessionalExp.vue';

export default {
  name: 'BoxProfessionalExp',

  data() {
    return {
      formsIds: [new Date().getTime()],
    };
  },

  computed: {
    experiences() {
      const { user } = this.$store.state;
      if (user.profile) {
        return this.$store.state.user.profile.professionalExperiences ? this.$helpers.sortBy(this.$store.state.user.profile.professionalExperiences, 'startYear', 'desc') : [];
      }
      return [];
    },

    no_experiences: {
      set(newValue) {
        this.$store.commit('SET_FLAG_PROFESSIONAL_EXPERIENCE', newValue);
      },
      get() {
        return this.$store.state.flag_no_professional_experience;
      },
    },
  },

  props: {
    format: {
      type: String,
      default: 'inline-form',
    },
  },

  components: {
    CloseIcon,
    PencilIcon,
    DeleteIcon,
    FormProfessionalExp,
  },

  methods: {
    addForm() {
      this.formsIds.push(new Date().getTime());
    },

    removeForm(item) {
      this.$swal({
        title: 'Atenção',
        text: 'Tem certeza que deseja remover a Experiência Profissional?',
        type: 'error',
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim, desejo remover',
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.formsIds = this.formsIds.filter((form) => form !== item);
        }
      });
    },

    edit(experience) {
      this.$refs['modal-professional-exp'].show();
      setTimeout(() => this.$EventBus.$emit('editingProfessionalExp', experience), 100);
    },

    remove(id) {
      if (!id) return;

      this.$swal({
        title: 'Atenção',
        text: 'Tem certeza que deseja remover a Experiência Profissional?',
        type: 'error',
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim, desejo remover',
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch('user/professionalExpDelete', { id });
        }
      });
    },

    dateRange(dateFrom, dateTo) {
      const a = this.$moment(dateTo);
      const b = this.$moment(dateFrom);
      let message = '';

      const years = a.diff(b, 'year');
      b.add(years, 'years');

      const months = a.diff(b, 'months');
      b.add(months, 'months');

      if (years > 0) message += `${years} anos `;
      if (months > 0) message += `${months} meses `;

      return message;
    },
  },
};
</script>
